import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { TextField, Typography, Collapse, Button, Alert } from "@mui/material";
import { useErrValidate } from "../utilitis/AuthorizationPage";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import SearchIcon from "@mui/icons-material/Search";
import { RolesContext } from "../context/User";
import ShippingList from "../component/ShippingList";
import { encode as base64_encode } from "base-64";
import CustomCard from "../styleComp/CustomCard";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export default function ShippingInvoice() {
  const [todate, settoDate] = useState("");
  const [fromdate, setfromDate] = useState("");
  const [ivnum, setIvnum] = useState("");
  const { validationPage } = useErrValidate();
  const [expanded, setExpanded] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [data, setData] = useState();
  const [displayAlert, setDisplayAlert] = useState("flex");
  const [stateroles, dispatchroles] = useContext(RolesContext);

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  const SearchData = () => {
    setClicked(clicked == true ? false : true);
    setData({ todate: todate, fromdate: fromdate, ivnum: ivnum });
    setIvnum("");
    // setfromDate("");
    // settoDate("");
  };

  useEffect(() => {
    validationPage("shipping");
  }, [stateroles.userId]);

  const handlefromdateChange = (event) => {
    setfromDate(event.target.value);
  };

  const handletodateChange = (event) => {
    settoDate(event.target.value);
  };

  const handleIvnum = (event) => {
    setIvnum(event.target.value);
  };

  return (
    <Container maxWidth="100%" sx={{ marginTop: "0.5rem" }}>
      <Box sx={{ flexGrow: 1, display: { xs: "none", md: "block" } }}>
        <CustomCard overflowCard={"scroll"}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h4"> תעודות משלוח</Typography>
            <Toolbar>
              <TextField
                sx={{ marginRight: "1rem" }}
                label="מספר תעודת משלוח"
                type="text"
                variant="outlined"
                value={ivnum}
                onChange={handleIvnum}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
              <TextField
                label="מ- תאריך"
                type="date"
                variant="outlined"
                value={fromdate}
                onChange={handlefromdateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
              <TextField
                sx={{ marginLeft: "1rem" }}
                label="עד- תאריך"
                type="date"
                variant="outlined"
                value={todate}
                onChange={handletodateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
              <Button
                endIcon={<SearchIcon />}
                sx={{
                  marginLeft: "3rem",
                  padding: "1rem",
                  paddingLeft: "1rem",
                }}
                onClick={SearchData}
              >
                חיפוש
              </Button>
            </Toolbar>
          </Grid>
          <br />
          <Alert
            severity="info"
            sx={{ display: displayAlert, marginBottom: "1rem" }}
            onClose={() => {
              setDisplayAlert("none");
            }}
          >
            ידוע למשתמש שיתכנו פערים בין המידע העדכני ביותר הקיים בידי החברה
            ו/או עיכובים לבין המידע המופיע או מוצג בפורטל ומידע כאמור אינו בהכרח
            מייצג את כל המידע שבידי החברה או המידע העדכני ביותר ליום הצפייה
          </Alert>
          <ShippingList
            // handleValueChange={handleValueChange}
            clicked={clicked}
            data={data}
          />
        </CustomCard>
      </Box>
      <Box sx={{ flexGrow: 1, display: { xs: "block", md: "none" } }}>
        <Typography variant="h4"> תעודות משלוח</Typography>
        <Button
          sx={{ color: "black",marginBottom: "1rem" }}
          startIcon={<ManageSearchIcon />}
          onClick={handleExpand}
          size="large"
        ></Button>
        <Collapse in={expanded}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={12}>
              <TextField
                sx={{ marginRight: "1rem" }}
                label="מספר תעובדות משלוח"
                type="text"
                variant="outlined"
                value={ivnum}
                onChange={handleIvnum}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                size="small"
                label="מ- תאריך"
                type="date"
                variant="outlined"
                value={fromdate}
                onChange={handlefromdateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{ marginTop: "0.5rem" }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                size="small"
                sx={{ marginTop: "0.5rem" }}
                label="עד- תאריך"
                type="date"
                variant="outlined"
                value={todate}
                onChange={handletodateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                endIcon={<SearchIcon />}
                size="large"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                onClick={SearchData}
              >
                חיפוש
              </Button>
            </Grid>
          </Grid>
        </Collapse>
        <Alert
          severity="info"
          sx={{ display: displayAlert, marginBottom: "1rem" }}
          onClose={() => {
            setDisplayAlert("none");
          }}
        >
          ידוע למשתמש שיתכנו פערים בין המידע העדכני ביותר הקיים בידי החברה ו/או
          עיכובים לבין המידע המופיע או מוצג בפורטל ומידע כאמור אינו בהכרח מייצג
          את כל המידע שבידי החברה או המידע העדכני ביותר ליום הצפייה
        </Alert>
        <ShippingList
          // handleValueChange={handleValueChange}
          clicked={clicked}
          data={data}
        />
      </Box>
    </Container>
  );
}
